import React from "react";
import { Logo } from "../../Logo/Logo";
import { MobileTrigger } from "../MobileTrigger";
import { NavigationWidgets } from "../NavigationWidgets";
export const MobileHeader = ({ logoHref, imageUrl, imageUrlReverse, language }) => (React.createElement("div", { className: "g-mobile-header__navigation g-mobile-header__wrapper" },
    React.createElement(Logo, { logoHref: logoHref ? logoHref : "/", imageUrl: imageUrl ? imageUrl : undefined, imageUrlReverse: imageUrlReverse ? imageUrlReverse : undefined }),
    React.createElement(NavigationWidgets, { language: language }),
    React.createElement(MobileTrigger, null)));
